import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("path", { key: '0', d: 'M56.5,12.5H8c-2.2,0-4,1.8-4,4v21.8c0,0,0,0.1,0,0.1c0,1.4,1.1,2.5,2.5,2.5h18.4c0.2,0,0.6,0.2,0.7,0.5\n\tc0.3,0.3,0.5,0.8,0.7,1.2c0.2,0.4,0.4,0.8,0.6,1.2c1-3.3,4-5.7,7.7-5.7c4.3,0,7.8,3.4,8,7.7c0,0,0,0,0,0c0-4.4,3.6-7.9,8-7.9\n\tc4.3,0,7.8,3.4,8,7.7c1.1-0.5,1.9-1.6,1.9-2.9v-4.2c0,0,0-0.1,0-0.1V16.5C60.5,14.3,58.7,12.5,56.5,12.5z' }),
    React.createElement("circle", { key: '1', cx: '34.6', cy: '45.8', r: '8' }),
    React.createElement("circle", { key: '2', fill: '#FFFFFF', cx: '34.6', cy: '45.8', r: '4.2' }),
    React.createElement("circle", { key: '3', cx: '50.6', cy: '45.5', r: '8' }),
    React.createElement("circle", { key: '4', fill: '#FFFFFF', cx: '50.6', cy: '45.5', r: '4.2' }),
], 'TransportTrailer');
const TransportTrailerIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportTrailerIcon);
